import DocsMenuSection from "../types/DocsMenuSection";


export default class DocsSectionUtils
{
    static loadedImages = {};

    static buildLeafUrlsFromMenu( menu: DocsMenuSection )
    {
        const menuSectionUrls: Array<string> = [];
        const menuSectionStack: Array<DocsMenuSection> = [ menu ];

        while ( menuSectionStack.length > 0 )
        {
            const menuSection: DocsMenuSection = ( menuSectionStack.pop() as DocsMenuSection );

            if ( menuSection.children.length > 0 )
            {
                Array.prototype.push.apply( menuSectionStack, menuSection.children );
            } else
            {
                menuSectionUrls.push( menuSection.url );
            }
        }

        return menuSectionUrls;
    }

    static buildHeaderUrlsFromMenu( menu: DocsMenuSection )
    {
        const menuSectionUrls: Array<string> = [];
        const menuSectionStack: Array<DocsMenuSection> = [ menu ];

        while ( menuSectionStack.length > 0 )
        {
            const menuSection: DocsMenuSection = ( menuSectionStack.pop() as DocsMenuSection );

            if ( menuSection.children.length > 0 )
            {
                menuSectionUrls.push( menuSection.url );
                Array.prototype.push.apply( menuSectionStack, menuSection.children );
            }
        }

        return menuSectionUrls;
    }

    static getActiveSection( url: string, menu: DocsMenuSection )
    {
        let bestMatch = '';
        let bestMatchLength = 0;

        const menuSectionUrls = DocsSectionUtils.buildLeafUrlsFromMenu( menu );

        for ( const menuSectionUrl of menuSectionUrls )
        {
            if ( url.indexOf( menuSectionUrl ) > -1 && menuSectionUrl.length > bestMatchLength )
            {
                bestMatch = menuSectionUrl;
                bestMatchLength = menuSectionUrl.length;
            }
        }

        return bestMatch;
    }

    static getOpenSection( url: string, menu: DocsMenuSection )
    {
        let bestMatch = '';
        let bestMatchLength = 0;

        const menuSectionUrls = DocsSectionUtils.buildHeaderUrlsFromMenu( menu );
        for ( const menuSectionUrl of menuSectionUrls )
        {
            if ( url.indexOf( menuSectionUrl ) > -1 && menuSectionUrl.length > bestMatchLength )
            {
                bestMatch = menuSectionUrl;
                bestMatchLength = menuSectionUrl.length;
            }
        }

        return bestMatch;
    }

    static findImage( id: string, isActive: boolean ): string | undefined
    {
        if ( !DocsSectionUtils.hasImage( id ) )
        {
            return undefined;
        }

        const allImages = DocsSectionUtils.loadedImages[ id ];
        const modifier = isActive ? 'active' : 'inactive';

        return allImages[ modifier ];
    }

    static hasImage( id: string ): boolean
    {
        return ( id !== "" ) && DocsSectionUtils.loadedImages.hasOwnProperty( id );
    }

    static loadTwoStateImage( id: string, imageName: string ): void
    {
        DocsSectionUtils.loadedImages[ id ] = {
            active: require( '../images/menu/active/' + imageName ),
            inactive: require( '../images/menu/inactive/' + imageName )
        };
    }

    static loadImages(): void
    {
        DocsSectionUtils.loadTwoStateImage( '_bidding', 'bidding.svg' );
        DocsSectionUtils.loadTwoStateImage( '_welcome_to_max', 'max.svg' );
        DocsSectionUtils.loadTwoStateImage( '_max_ui', 'api.svg' );
        DocsSectionUtils.loadTwoStateImage( '_adobe_air', 'adobe_air.svg' );
        DocsSectionUtils.loadTwoStateImage( '_android', 'android.svg' );
        DocsSectionUtils.loadTwoStateImage( '_cordova', 'cordova.svg' );
        DocsSectionUtils.loadTwoStateImage( '_defold', 'defold.svg' );
        DocsSectionUtils.loadTwoStateImage( '_flutter', 'flutter.svg' );
        DocsSectionUtils.loadTwoStateImage( '_godot', 'godot.svg' );
        DocsSectionUtils.loadTwoStateImage( '_ios', 'ios.svg' );
        DocsSectionUtils.loadTwoStateImage( '_react_native', 'react_native.svg' );
        DocsSectionUtils.loadTwoStateImage( '_unity', 'unity.svg' );
        DocsSectionUtils.loadTwoStateImage( '_unreal', 'unreal.svg' );
        DocsSectionUtils.loadTwoStateImage( '_reporting_apis', 'reporting_apis.svg' );
        DocsSectionUtils.loadTwoStateImage( '_max_features', 'advanced_features.svg' );
        DocsSectionUtils.loadTwoStateImage( '_ad_review', 'magnifying_glass_gray.svg' );
        DocsSectionUtils.loadTwoStateImage( '_ab_test', 'mediation_experiment.svg' );
        DocsSectionUtils.loadTwoStateImage( '_success', 'success.svg' );
        DocsSectionUtils.loadTwoStateImage( '_help_center', 'help.svg' );
        DocsSectionUtils.loadTwoStateImage( 'menu_arrow', 'menu_arrow.svg' );
    }
}

DocsSectionUtils.loadImages();

